import { fn } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import GeneralButtonsButtonsPreviousNextSmall from 'lumen/components/general/buttons/buttons-previous-next-small';

interface GeneralModalsModalHeaderDateSelectionSignature {
  Args: {
    beginReached: unknown;
    changeDayAction: unknown;
    endReached: unknown;
  };
  Element: HTMLDivElement;
}

export default class GeneralModalsModalHeaderDateSelection extends Component<GeneralModalsModalHeaderDateSelectionSignature> {
  /**
   * Action triggered whenever you select the arrows to change the date
   * @param  {Boolean} next True if you clicked the right-side arrow
   */
  @action
  // @ts-expect-error: Incorrect type
  changeDay(next): void {
    if ((next && !this.args.endReached) || (!next && !this.args.beginReached)) {
      // @ts-expect-error: Incorrect type
      this.args.changeDayAction(next);
    }
  }

  <template>
    <div ...attributes>
      <GeneralButtonsButtonsPreviousNextSmall
        {{! @glint-expect-error: Incorrect type }}
        @beginReached={{@beginReached}}
        @dataEventIdNext="modal-header-datepicker-next"
        @dataEventIdPrevious="modal-header-datepicker-previous"
        {{! @glint-expect-error: Incorrect type }}
        @endReached={{@endReached}}
        @nextClicked={{fn this.changeDay true}}
        @previousClicked={{fn this.changeDay false}}
      />
    </div>
  </template>
}
